<template>
  <base-modal
    v-if="modelValue !== null"
    hide-footer
    hide-header
    size="lg"
    @close="$emit('cancel')"
  >
    <material-station-editor
      :station="modelValue"
      :is-observer="isObserver"
      :is-worker="isWorker"
      :disabled="loading"
      @close-and-update="submitStation"
      @cancel="$emit('cancel')"
    />
    <div
      v-if="loading"
      class="spinner"
    />
  </base-modal>
</template>

<script>
import BaseModal from "@/components/BaseModal";
import {restApi} from "@/components/mixins/RestApiMixin";
import MaterialStationEditor from "./MaterialStationEditor";
import {inject} from "vue";

export default {
    name: "MaterialStationModal",
    components: {MaterialStationEditor, BaseModal},
    mixins: [restApi],
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        isWorker: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        submitStation: function (station) {
            this.loading = true
            if (station.id < 0) {
                this.restAdd(this.materialStationUrl, station, this.success, this.fail)
            } else {
                this.restUpdate(this.materialStationUrl, station, this.success, this.fail)
            }
        },
        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        }
    }
}
</script>
